var accuCodeService = null;
var translate = null;
var personalMessagingFactory = null;
var httpProvider = null;

var PersonalMessagingDirective = function (
    AccuCodeService,
    $http,
    $translate,
    $state,
    $rootScope,
    personalMessagingFactory,
    $cookies
) {
    accuCodeService = AccuCodeService;
    translate = $translate;
    personalMessagingFactory = personalMessagingFactory;
    httpProvider = $http;
    return {
        replace: "true",
        restrict: "AE",
        template: `<div id="{{ pmId }}" ng-show="showPM"></div>`,
        scope: {
            heading: "@",
            blueConicData: "@",
            src: "@"
        },
        link: function (scope, element, attr) {
            loadScript(scope, element, attr);
        }
    };

    function loadScript(scope, element, attr) {
        scope.heading = "Plan Messaging";

        var gaID = null;
        scope.pmId = "pmHome";
        scope.showPM = false;
        $rootScope.showHeading = false;
        $rootScope.pmEnabled = false;
    }
};

PersonalMessagingDirective.$inject = [
    "AccuCodeService",
    "$http",
    "$translate",
    "$state",
    "$rootScope",
    "personalMessagingFactory",
    "$cookies"
];

export default PersonalMessagingDirective;
